export default __webpack_public_path__ + "static/media/imageFour.c085f216.png";